import { render } from "./ViewGasFreeReportComponent.vue?vue&type=template&id=2565713a"
import script from "./ViewGasFreeReportComponent.vue?vue&type=script&lang=js"
export * from "./ViewGasFreeReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__